<template>
    <div class="d-flex align-items-center flex-grow-1" style="height: 24px">
        <input ref="rangeInput" type="range" :min="min" :max="max" :step="step" :value="value">
    </div>
</template>

<script>
import 'rangeslider.js';

export default {
    name: 'RangeSlider',
    props: {
        min: {
            default: 0
        },
        max: {
            default: 100
        },
        step: {
            default: 1
        },
        value: {
            default: 50
        }
    },
    data() {
        return {
            canEmit: true,
        }
    },
    mounted() {
        $(this.$refs.rangeInput).rangeslider({
            polyfill: false,
            onSlide: (position, value) => {
                if (this.value === value || !this.canEmit) {
                    return;
                }
                this.$emit('input', value);
            }
        });
    },
    beforeDestroy() {
        $(this.$refs.rangeInput).rangeslider('destroy');
    },
    watch: {
        value(newValue) {
            this.canEmit = false;
            $(this.$refs.rangeInput).val(newValue).rangeslider('update', true);
            this.canEmit = true;
        }
    }
}
</script>

<style lang="scss">
    @import 'rangeslider.js/dist/rangeslider.css';

    .rangeslider__handle {
        border: none;
        width: 22px;
        height: 22px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);

        &:after {
            background-image: none;
        }
    }

    .rangeslider--horizontal .rangeslider__handle {
        top: -8px;
    }

    .rangeslider--horizontal {
        height: 7px;
    }

    .rangeslider__fill {
        background: #C64885;
    }

    .rangeslider {
        box-shadow: inset 0px 1px 5px rgba(0, 0, 0, 0.18);
    }
</style>
